export const getBasicAuthHeader = (
    username: string,
    password: string,
): string => {
    const credentials = `${username}:${password}`;
    const base64Credentials = btoa(credentials);
    return `Basic ${base64Credentials}`;
};
